/**
 * Whole minutes elapsed since the given ISO timestamp, clamped at 0.
 * Returns 0 for empty / unparseable input. Used by the live-recording hero
 * (both the Lexicanon `MeetingHeroLive` card and the Voxcanon hero on the
 * meeting list) to render "started N min ago".
 */
export function minutesSince(iso: string): number {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return 0
  return Math.max(0, Math.round((Date.now() - d.getTime()) / 60_000))
}
